import { render, staticRenderFns } from "./ProvinceSelect.vue?vue&type=template&id=67ae835c&scoped=true"
import script from "./ProvinceSelect.vue?vue&type=script&lang=ts"
export * from "./ProvinceSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae835c",
  null
  
)

export default component.exports